export default "__VITE_ASSET__3e6d101f__"